import Vue from 'vue'
import Router from 'vue-router'

import PageDynamic from '@/pages/PageDynamic.vue'

Vue.use(Router)

export default new Router({
    abstract: true,
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior: function(to) {
        if (to.hash) {
            return {selector: to.hash}
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: configRoutes()
})

function configRoutes () {
    return [
        {
            path: '/',
            redirect: '/home'
        },
        {
            path: '/home',
            name: 'Startseite',
            component: PageDynamic,
            props: {
                pageId: 'home'
            }
        },
        {
            path: '/news',
            name: 'Aktuelles',
            component: PageDynamic,
            props: {
                pageId: 'news'
            }
        },
        {
            path: '/location',
            name: 'Lage',
            component: PageDynamic,
            props: {
                pageId: 'location'
            }
        },
        {
            path: '/emblem',
            name: 'Wappen',
            component: PageDynamic,
            props: {
                pageId: 'emblem'
            }
        },
        {
            path: '/history',
            name: 'Geschichte',
            component: PageDynamic,
            props: {
                pageId: 'history'
            }
        },
        {
            path: '/member',
            name: 'Mitglied werden...',
            component: PageDynamic,
            props: {
                pageId: 'member'
            }
        },
        {
            path: '/persons',
            name: 'Ansprechpartner',
            component: PageDynamic,
            props: {
                pageId: 'persons'
            }
        },
        {
            path: '/mission',
            name: 'Aufgaben',
            component: PageDynamic,
            props: {
                pageId: 'mission'
            }
        },
        {
            path: '/contact',
            name: 'Kontakt',
            component: PageDynamic,
            props: {
                pageId: 'contact'
            }
        },
        {
            path: '/imprint',
            name: 'Impressum',
            component: PageDynamic,
            props: {
                pageId: 'imprint'
            }
        },
        {
            path: '/privacy',
            name: 'Datenschutz',
            component: PageDynamic,
            props: {
                pageId: 'privacy'
            }
        },
    ]
}

